<template>
  <div class="main-wrapper" ref="mainWrapper">
    <div
      class="input-wrap flex"
      :class="{ 'read-only': readonly, disabled: disabled }"
      @click="handleShowSelector"
    >
      <span class="el-icon-date"></span>
      <input
        type="text"
        :placeholder="startPlaceholder"
        :value="`${selectedStart.replace(/\//g, '-')}`"
        :readonly="readonly"
        :disabled="disabled"
        :class="{ disabled: disabled }"
      />
      <span>{{ rangeSeparator }}</span>
      <input
        type="text"
        :placeholder="endPlaceholder"
        :value="`${selectedEnd.replace(/\//g, '-')}`"
        :readonly="readonly"
        :disabled="disabled"
        :class="{ disabled: disabled }"
      />
      <span
        class="el-icon-circle-close"
        :class="{ disappear: selectedStart || selectedEnd }"
        @click.stop="handleClear"
        v-if="clearable && !readonly"
      ></span>
    </div>
    <div
      class="float-shadow"
      ref="floatShadowRef"
      v-show="selectorVisible"
      @click="handleHideSelector"
    ></div>
    <div class="float-wrap" v-show="selectorVisible" ref="floatWrapRef">
      <div class="calender-wrap">
        <div class="calender">
          <div class="month-wrap">
            <i
              class="arrow el-icon-d-arrow-left"
              @click="handleYearMonthChange('left-left-year')"
            ></i>
            <i
              class="arrow el-icon-arrow-left"
              @click="handleYearMonthChange('left-left-month')"
            ></i>
            <span class="text flex">
              <span>{{ leftCalenderYear }}年{{ leftCalenderMonth }}月</span>
              <common-year-month-selector
                @confirm="handleLeftConfirm"
                :CalenderYear="leftCalenderYear"
                :CalenderMonth="leftCalenderMonth"
              ></common-year-month-selector>
            </span>
            <i
              class="arrow el-icon-arrow-right"
              @click="handleYearMonthChange('left-right-month')"
              :class="{
                disable: !canMonthChange,
              }"
            ></i>
            <i
              class="arrow el-icon-d-arrow-right"
              @click="handleYearMonthChange('left-right-year')"
              :class="{
                disable: !canYearChange,
              }"
            ></i>
          </div>
          <div class="week-wrap">
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
            <span>日</span>
          </div>
          <div class="day-wrap">
            <div
              class="day"
              :style="{
                width: userAgent.toLocaleLowerCase().includes('edg')
                  ? '31px'
                  : '32px',
              }"
              :class="{
                active: day === selectedStartCache || day === selectedEndCache,
                // 未来日期不可选，如果选择的月份和天数大与当前月份和天数，则不可选
                out:
                  Number(day.slice(5, 7)) !== leftCalenderMonth ||
                  handlePickerOptions(day),
                in:
                  selectedStartCache &&
                  selectedEndCache &&
                  day > selectedStartCache &&
                  day < selectedEndCache,
              }"
              v-for="day in leftCalenderDays"
              :key="day"
            >
              <span class="circle" @click="handleDayClick(day)">{{
                day.slice(-2)
              }}</span>
            </div>
          </div>
        </div>
        <div class="calender">
          <div class="month-wrap">
            <i
              class="arrow el-icon-d-arrow-left"
              @click="handleYearMonthChange('right-left-year')"
              :class="{
                disable: !canYearChange,
              }"
            ></i>
            <i
              class="arrow el-icon-arrow-left"
              @click="handleYearMonthChange('right-left-month')"
              :class="{
                disable: !canMonthChange,
              }"
            ></i>
            <span class="text">
              <span>{{ rightCalenderYear }}年{{ rightCalenderMonth }}月</span>
              <common-year-month-selector
                @confirm="handleRightConfirm"
                :CalenderYear="rightCalenderYear"
                :CalenderMonth="rightCalenderMonth"
              ></common-year-month-selector>
            </span>
            <i
              class="arrow el-icon-arrow-right"
              @click="handleYearMonthChange('right-right-month')"
            ></i>
            <i
              class="arrow el-icon-d-arrow-right"
              @click="handleYearMonthChange('right-right-year')"
            ></i>
          </div>
          <div class="week-wrap">
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
            <span>日</span>
          </div>
          <div class="day-wrap">
            <div
              class="day"
              :style="{
                width: userAgent.toLocaleLowerCase().includes('edg')
                  ? '31px'
                  : '32px',
              }"
              :class="{
                active: day === selectedEndCache || day === selectedStartCache,
                // 未来日期不可选
                out:
                  Number(day.slice(5, 7)) !== rightCalenderMonth ||
                  handlePickerOptions(day),
                in:
                  selectedStartCache &&
                  selectedEndCache &&
                  day > selectedStartCache &&
                  day < selectedEndCache,
              }"
              v-for="day in rightCalenderDays"
              :key="day"
            >
              <span class="circle" @click="handleDayClick(day)">{{
                day.slice(-2)
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <div class="button" @click="quickGetDateRange('today')">今天</div>
        <div class="button" @click="quickGetDateRange('yesterday')">昨天</div>
        <div class="button" @click="quickGetDateRange('currentWeek')">本周</div>
        <div class="button" @click="quickGetDateRange('lastWeek')">上周</div>
        <div class="button" @click="quickGetDateRange('last7Day')">最近7天</div>
        <div class="button" @click="quickGetDateRange('currentMonth')">
          本月
        </div>
        <div class="button" @click="quickGetDateRange('lastMonth')">上月</div>
        <div class="button" @click="quickGetDateRange('last30Day')">
          最近30天
        </div>
        <div class="button" @click="quickGetDateRange('last3Month')">
          最近3个月
        </div>
        <div class="button" @click="quickGetDateRange('currentYear')">本年</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  dateFormat,
  getCurrentWeek,
  getCurrentMonth,
} from "@/utils/timeFormat";
import commonYearMonthSelector from "./commonYearMonthSelector.vue";
export default {
  components: {
    commonYearMonthSelector,
  },
  // value：双向绑定 v-model，通过 props 接收 value，通过 emit 回传 input
  /**pickerOptions:未来时间不可选，默认为 undefined，disabledDate 回调函数；
   * 参数 1 为日历中的每一天；
   * 参数 2 选择日期后的的起始日期，再根据起始日期过滤展示可选日期 */
  // clearable:是否展示清除按钮，默认 true
  // valueFormat:输出日期数据类型为标准时间 new Date()、yyyy-mm-dd 或 时间戳
  // startPlaceholder:开始时间的占位内容
  // rangeSeparator:选择范围时的分隔符
  // endPlaceholder:结束时间的占位内容
  // readonly:是否为只读
  // disabled:是否不可用
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array | String,
    },
    pickerOptions: {
      type: Object,
      default: undefined,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    valueFormat: {
      type: String,
    },
    startPlaceholder: {
      type: String,
      default: "开始时间",
    },
    rangeSeparator: {
      type: String,
      default: "至",
    },
    endPlaceholder: {
      type: String,
      default: "结束时间",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leftCalenderYear: 2024,
      leftCalenderMonth: 1,
      rightCalenderYear: 2024,
      rightCalenderMonth: 2,
      leftCalenderDays: [],
      rightCalenderDays: [],
      selectedStartCache: "",
      selectedStart: "",
      selectedEndCache: "",
      selectedEnd: "",
      selectorVisible: false,
      leftConfirm: "",
      rightConfirm: "",
      userAgent: "", // 当前浏览器型号
      dayClick: false,
    };
  },
  computed: {
    canYearChange() {
      return (
        this.leftCalenderYear + 1 < this.rightCalenderYear ||
        (this.leftCalenderYear + 1 === this.rightCalenderYear &&
          this.leftCalenderMonth < this.rightCalenderMonth)
      );
    },
    canMonthChange() {
      return (
        this.leftCalenderYear < this.rightCalenderYear ||
        (this.leftCalenderYear === this.rightCalenderYear &&
          this.leftCalenderMonth + 1 < this.rightCalenderMonth)
      );
    },
  },
  created() {
    this.createCalender(new Date());
    this.userAgent = navigator.userAgent;
  },
  watch: {
    value: {
      handler(n) {
        // console.log("watch", this.value);
        if (n && n.length > 0) {
          if (this.valueFormat === "yyyy-mm-dd") {
            this.selectedStartCache = n[0].replace(/-/g, "/");
            this.selectedStart = n[0].replace(/-/g, "/");
            this.selectedEndCache = n[1].replace(/-/g, "/");
            this.selectedEnd = n[1].replace(/-/g, "/");
          } else {
            this.selectedStartCache = dateFormat("YYYY/mm/dd", n[0]);
            this.selectedStart = dateFormat("YYYY/mm/dd", n[0]);
            this.selectedEndCache = dateFormat("YYYY/mm/dd", n[1]);
            this.selectedEnd = dateFormat("YYYY/mm/dd", n[1]);
          }
        } else {
          this.selectedStartCache = "";
          this.selectedStart = "";
          this.selectedEndCache = "";
          this.selectedEnd = "";
        }
      },
      immediate: true,
      deep: false,
    },
    selectorVisible: {
      // 移除添加的 dom 元素
      handler(n) {
        if (!n) {
          let floatShadowRef = this.$refs["floatShadowRef"];
          let floatWrapRef = this.$refs["floatWrapRef"];
          document.body.removeChild(floatShadowRef);
          document.body.removeChild(floatWrapRef);
        }
      },
      immediate: false,
      deep: false,
    },
  },
  mounted() {
    let mainWrapper = this.$refs["mainWrapper"];
    mainWrapper.addEventListener("click", this.handleMainWrapperClick);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.dayClick = false;
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize(evt) {
      let floatWrapRef = this.$refs["floatWrapRef"];
      let mainWrapper = this.$refs["mainWrapper"];
      let mainWrapperBounding = mainWrapper.getBoundingClientRect();
      let innerWidth = evt.target.innerWidth;
      let cul = innerWidth - mainWrapperBounding.left - 330;
      // 如果当前窗口 - mainWrapper 到左边的距离 - 自身宽度 的值小于 150，则 right 固定
      if (cul < 150) {
        floatWrapRef.style.left = "auto";
        floatWrapRef.style.right = 2 + "%";
      } else {
        floatWrapRef.style.left = mainWrapperBounding.left - 120 + "px";
        floatWrapRef.style.right = "auto";
      }
    },
    handleMainWrapperClick(evt) {
      let mainWrapper = this.$refs["mainWrapper"];
      // 获取 mainWrapper 元素的物理信息，获取到当前窗口最顶端的 top 值
      let mainWrapperBounding = mainWrapper.getBoundingClientRect();
      let floatShadowRef = this.$refs["floatShadowRef"];
      let floatWrapRef = this.$refs["floatWrapRef"];
      // 追加到 body 内，避免出现被溢出隐藏掉
      document.body.appendChild(floatShadowRef);
      document.body.appendChild(floatWrapRef);
      floatWrapRef.style.left = "auto";
      floatWrapRef.style.right = "auto";
      // 如果 mainWrapper 距离窗口顶部大于 450 ，则向上展开
      if (mainWrapperBounding.top > 450) {
        floatWrapRef.style.top = mainWrapperBounding.top - 343 + "px"; // 基于 mianWrap 向上
      } else {
        floatWrapRef.style.top = mainWrapperBounding.top + 30 + "px"; // 基于 mianWrap 向下
      }
      let cul = evt.view.innerWidth - mainWrapperBounding.left - 330;
      // 如果当前窗口 - mainWrapper 到左边的距离 - 自身宽度 的值小于 150，则 right 固定
      if (cul < 150) {
        floatWrapRef.style.left = "auto";
        floatWrapRef.style.right = 2 + "%";
      } else {
        floatWrapRef.style.left = mainWrapperBounding.left - 120 + "px";
        floatWrapRef.style.right = "auto";
      }
    },
    dateFormat(timeStamp) {
      let target = new Date(timeStamp);
      let m = target.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = target.getDate();
      d = d < 10 ? "0" + d : d;
      return target.getFullYear() + "/" + m + "/" + d;
    },
    handleYearMonthChange(type) {
      if (type === "left-left-year") {
        this.leftCalenderYear = this.leftCalenderYear - 1;
      }
      if (type === "left-left-month") {
        if (this.leftCalenderMonth === 1) {
          this.leftCalenderYear = this.leftCalenderYear - 1;
          this.leftCalenderMonth = 12;
        } else {
          this.leftCalenderMonth = this.leftCalenderMonth - 1;
        }
      }
      if (type === "left-right-month") {
        if (!this.canMonthChange) {
          return false;
        }
        if (this.leftCalenderMonth === 12) {
          this.leftCalenderYear = this.leftCalenderYear + 1;
          this.leftCalenderMonth = 1;
        } else {
          this.leftCalenderMonth = this.leftCalenderMonth + 1;
        }
      }
      if (type === "left-right-year") {
        if (!this.canYearChange) {
          return false;
        }
        this.leftCalenderYear = this.leftCalenderYear + 1;
      }
      if (type === "right-left-year") {
        if (!this.canYearChange) {
          return false;
        }
        this.rightCalenderYear = this.rightCalenderYear - 1;
      }
      if (type === "right-left-month") {
        if (!this.canMonthChange) {
          return false;
        }
        if (this.rightCalenderMonth === 1) {
          this.rightCalenderYear = this.rightCalenderYear - 1;
          this.rightCalenderMonth = 12;
        } else {
          this.rightCalenderMonth = this.rightCalenderMonth - 1;
        }
      }
      if (type === "right-right-month") {
        if (this.rightCalenderMonth === 12) {
          this.rightCalenderYear = this.rightCalenderYear + 1;
          this.rightCalenderMonth = 1;
        } else {
          this.rightCalenderMonth = this.rightCalenderMonth + 1;
        }
      }
      if (type === "right-right-year") {
        this.rightCalenderYear = this.rightCalenderYear + 1;
      }
      this.createCalender(
        new Date(this.leftCalenderYear + "/" + this.leftCalenderMonth + "/1"),
        new Date(this.rightCalenderYear + "/" + this.rightCalenderMonth + "/1")
      );
    },
    // 生成左右两个日历
    createCalender(start, end, type) {
      if (!start) {
        return false;
      }
      let startY = start.getFullYear();
      let startM = start.getMonth() + 1;
      if (type === "right") {
        if (end.getMonth() + 1 === 1) {
          startM = 12;
        } else {
          startY = end.getFullYear();
          startM = end.getMonth();
        }
      } else {
        if (
          !end ||
          (start.getFullYear() === end.getFullYear() &&
            start.getMonth() === end.getMonth())
        ) {
          if (startM === 12) {
            end = new Date(startY + 1 + "/1/1");
          } else {
            end = new Date(startY + "/" + (startM + 1) + "/1");
          }
        }
      }

      let endY = end.getFullYear();
      let endM = end.getMonth() + 1;
      this.leftCalenderYear = startY;
      this.leftCalenderMonth = startM;
      this.rightCalenderYear = endY;
      this.rightCalenderMonth = endM;
      let startMonthFristDay = new Date(startY + "/" + startM + "/1");
      let endMonthFristDay = new Date(endY + "/" + endM + "/1");
      // 固定取6行，即6*7=42格
      let startMonthDays = [];
      let sTime =
        startMonthFristDay.getTime() -
        (startMonthFristDay.getDay() || 7) * 24 * 60 * 60 * 1000;
      for (let i = 0; i < 42; i++) {
        sTime = sTime + 24 * 60 * 60 * 1000;
        startMonthDays.push(this.dateFormat(sTime));
      }
      let endMonthDays = [];
      let eTime =
        endMonthFristDay.getTime() -
        (endMonthFristDay.getDay() || 7) * 24 * 60 * 60 * 1000;
      for (let i = 0; i < 42; i++) {
        eTime = eTime + 24 * 60 * 60 * 1000;
        endMonthDays.push(this.dateFormat(eTime));
      }
      this.leftCalenderDays = startMonthDays;
      this.rightCalenderDays = endMonthDays;
    },
    // 快捷选择时间段
    quickGetDateRange(type, start) {
      const target = start ? start : new Date();
      let res = [];
      if (type === "today") {
        res = [target, target];
      }
      if (type === "yesterday") {
        res = [
          new Date(target.getTime() - 24 * 60 * 60 * 1000),
          new Date(target.getTime() - 24 * 60 * 60 * 1000),
        ];
      }
      if (type === "currentWeek") {
        let cw = getCurrentWeek(target);
        if (this.pickerOptions && cw[1].getTime() > Date.now()) {
          cw[1] = new Date();
        }
        res = [cw[0], cw[1]];
      }
      if (type === "lastWeek") {
        let lw = getCurrentWeek(target.getTime() - 7 * 24 * 60 * 60 * 1000);
        res = [lw[0], lw[1]];
      }
      if (type === "last7Day") {
        res = [
          new Date(target.getTime() - 7 * 24 * 60 * 60 * 1000),
          new Date(target.getTime()),
        ];
      }
      if (type === "currentMonth") {
        let cm = getCurrentMonth(target);
        if (this.pickerOptions && cm[1].getTime() > Date.now()) {
          cm[1] = new Date();
        }
        res = [cm[0], cm[1]];
      }
      if (type === "lastMonth") {
        let lm = getCurrentMonth(
          target.getTime() - target.getDate() * 24 * 60 * 60 * 1000
        );
        res = [lm[0], lm[1]];
      }
      if (type === "last30Day") {
        res = [
          new Date(target.getTime() - 30 * 24 * 60 * 60 * 1000),
          new Date(target.getTime()),
        ];
      }
      if (type === "last3Month") {
        let y = target.getFullYear();
        let m = target.getMonth() + 1;
        if (m < 3) {
          y = y - 1;
          m = m + 12 - 2;
        } else {
          m = m - 2;
        }
        res = [new Date(y + "/" + m + "/1"), target];
      }
      if (type === "currentYear") {
        if (this.pickerOptions) {
          res = [new Date(target.getFullYear() + "/1/1"), new Date()];
        } else {
          res = [
            new Date(target.getFullYear() + "/1/1"),
            new Date(target.getFullYear() + "/12/31"),
          ];
        }
      }
      this.selectedStartCache = dateFormat("YYYY/mm/dd", res[0] || "");
      this.selectedEndCache = dateFormat("YYYY/mm/dd", res[1] || "");
      this.createCalender(res[0], res[1]);
      this.handleHideSelector();
    },
    handlePickerOptions(day) {
      if (this.pickerOptions) {
        // 点击了 day 之后，传第二个参数
        if (this.dayClick) {
          return this.pickerOptions.disabledDate(
            new Date(day),
            new Date(this.selectedStartCache)
          );
        } else {
          return this.pickerOptions.disabledDate(new Date(day), "");
        }
      } else {
        return false;
      }
    },
    handleDayClick(day) {
      // 点击了 day 之后，传第二个参数并校验
      if (this.dayClick) {
        if (
          this.pickerOptions &&
          this.pickerOptions.disabledDate(
            new Date(day),
            new Date(this.selectedStartCache) || ""
          )
        )
          return;
        // 未点击时，校验第一个参数
      } else {
        if (
          this.pickerOptions &&
          this.pickerOptions.disabledDate(new Date(day))
        ) {
          return;
        }
      }

      if (this.selectedEndCache) {
        this.selectedStartCache = day;
        this.selectedEndCache = "";
      } else {
        if (this.selectedStartCache) {
          this.selectedEndCache = day;
          this.handleHideSelector();
        } else {
          this.selectedStartCache = day;
        }
      }
      this.dayClick = true;
    },
    handleShowSelector() {
      if (this.readonly || this.disabled) return;
      if (this.selectedStart && this.selectedEnd) {
        this.selectedStartCache = this.selectedStart;
        this.selectedEndCache = this.selectedEnd;
        this.createCalender(
          new Date(this.selectedStartCache),
          new Date(this.selectedEndCache)
        );
      }
      this.selectorVisible = true;
    },
    handleClear() {
      if (this.disabled) return;
      this.selectorVisible = false;
      this.selectedStartCache = "";
      this.selectedEndCache = "";
      this.selectedStart = "";
      this.selectedEnd = "";
      this.$emit("input", "");
      this.$emit("change");
    },
    handleHideSelector() {
      if (this.selectedStartCache && this.selectedEndCache) {
        // 用户可能先选终点再选起点
        if (
          new Date(this.selectedStartCache).getTime() >
          new Date(this.selectedEndCache).getTime()
        ) {
          let s = this.selectedStartCache;
          let e = this.selectedEndCache;
          this.selectedStartCache = e;
          this.selectedStart = e;
          this.selectedEndCache = s;
          this.selectedEnd = s;
        } else {
          this.selectedStart = this.selectedStartCache;
          this.selectedEnd = this.selectedEndCache;
        }
      } else {
        this.selectedStartCache = "";
        this.selectedEndCache = "";
      }
      this.selectorVisible = false;
      // 回传更新，与之前的日期数据结构同步
      if (this.selectedStart && this.selectedEnd) {
        if (this.valueFormat === "yyyy-MM-dd") {
          this.$emit("input", [
            this.selectedStart.replace(/\//g, "-"),
            this.selectedEnd.replace(/\//g, "-"),
          ]);
          this.$emit("change");
        } else if (this.valueFormat === "timestamp") {
          this.$emit("input", [
            new Date(this.selectedStart).getTime(),
            new Date(this.selectedEnd).getTime(),
          ]);
          this.$emit("change");
        } else {
          this.$emit("input", [
            new Date(this.selectedStart),
            new Date(this.selectedEnd),
          ]);
          this.$emit("change");
        }
      }
      // 异步重置为 false
      setTimeout(() => {
        this.dayClick = false;
      }, 100);
    },
    // 选中的年月回传
    handleLeftConfirm(evt) {
      this.leftComfirm = new Date(`${evt.curYear}/${evt.curMonth}/01`);
      this.createCalender(this.leftComfirm);
    },
    handleRightConfirm(evt) {
      this.rightConfirm = new Date(`${evt.curYear}/${evt.curMonth}/01`);
      if (evt.curYear < new Date().getFullYear()) {
        this.createCalender(
          this.leftComfirm ||
            new Date(`${this.leftCalenderYear}/${this.leftCalenderMonth}/01`),
          this.rightConfirm,
          "right"
        );
        return false;
      }
      if (evt.curMonth > new Date().getMonth() + 1) return;
      this.createCalender(
        this.leftComfirm ||
          new Date(`${this.leftCalenderYear}/${this.leftCalenderMonth}/01`),
        this.rightConfirm,
        "right"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.main-wrapper {
  display: inline-block;
  position: relative;
  width: 100%;

  .input-wrap {
    width: 100%;
    cursor: pointer;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    padding: 2px 0;
    border: 1px solid #e7e8ea;
    position: relative;
    border-radius: 3px;
    color: #c0c4cc;
    input {
      border: none !important;
      text-align: center !important;
      width: 50%;
    }
    .el-icon-date {
      margin-left: 12px;
    }
    .el-icon-circle-close {
      opacity: 0;
      margin-right: 12px;
    }
    .disappear {
      opacity: 1;
    }
    .clear {
      width: 17px;
      height: 17px;
      position: absolute;
      top: 3px;
      right: 3px;
      object-fit: cover;
    }
  }
}
.read-only {
  cursor: default !important;
}
.disabled {
  background: #f5f7fa;
  cursor: not-allowed !important;
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.float-shadow {
  position: fixed;
  // position: absolute;
  z-index: 2999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
}
.float-wrap {
  position: absolute;
  z-index: 3001;
  top: 0;
  // transform: translateX(-45px);
  background-color: #fff;
  box-shadow: 0 0 4px 1px rgba(100, 100, 100, 0.1);
  .calender-wrap {
    padding: 12px;
    display: flex;
    .calender {
      width: 238px;
      display: inline-block;
      &:first-child {
        margin-right: 16px;
      }
      .month-wrap {
        text-align: center;
        font-size: 14px;
        line-height: 18px;
        color: #333;
        border-bottom: 1px solid #e7e8ea;
        padding-bottom: 10px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .arrow {
          padding: 0 2px;
          cursor: pointer;
          color: #07d1aa;
          font-size: 16px;
          &.disable {
            cursor: not-allowed;
            color: #ddd;
          }
        }
        .text {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .week-wrap {
        display: flex;
        border-bottom: 1px solid #e7e8ea;
        padding-bottom: 10px;
        margin-bottom: 10px;
        span {
          flex: 1;
          font-size: 14px;
          color: #333;
          line-height: 16px;
          text-align: center;
        }
      }
      .day-wrap {
        .day {
          // width: 32px;
          height: 32px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          &.active {
            .circle {
              background-color: #07d1aa;
              color: #fff;
            }
          }
          &.out {
            .circle {
              cursor: not-allowed !important;
              color: #ddd !important;
              background-color: #fff !important;
            }
          }
          &.in {
            .circle {
              background-color: rgba(7, 209, 170, 0.15);
            }
          }
          .circle {
            text-align: center;
            font-size: 12px;
            line-height: 26px;
            height: 26px;
            width: 26px;
            border-radius: 4px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .button-wrap {
    margin: 0 12px;
    padding: 12px 0;
    border-top: 1px solid #e7e8ea;
    .button {
      display: inline-block;
      font-size: 12px;
      line-height: 22px;
      border: 1px solid #07d1aa;
      color: #07d1aa;
      border-radius: 4px;
      padding: 0 6px;
      cursor: pointer;
      margin-right: 4px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
